export { useDocumentsForm } from './documents-form/useDocumentsForm';

export * from './utilities';

export {
	useCommonFieldsStructure as useDocumentsCommonFieldsStructure,
	useHasEmiratesIdFieldsStructure as useDocumentsHasEmiratesIdFieldsStructure,
	useMemberDetailsFieldsStructure as useDocumentsMemberDetailsFieldsStructure,
} from './documents-form/fields-structures';

export type { DocumentsReactForm } from './documents-form/types';
